import src from "IMAGE";
export default { src, width: 1944, height: 732, blurWidth: 0, blurHeight: 0};
